import { render } from "./ProjectLocalBudget.vue?vue&type=template&id=826ba102&scoped=true"
import script from "./ProjectLocalBudget.vue?vue&type=script&lang=js"
export * from "./ProjectLocalBudget.vue?vue&type=script&lang=js"

import "./ProjectLocalBudget.vue?vue&type=style&index=0&id=826ba102&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-826ba102"]])

export default __exports__